const skipEgmOptions = ['63327', '66465', '63328', '66505', '66506', '66507', '66508', '66509', '67984', '67985', '66466'];

/* Staging record IDs
const skipEgmOptions = ['59813', '59814', '59880', '59881', '59882', '59883', '59884', '59885', '59886']; */

export default skipEgmOptions;
